import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../api.service';
import { CommonService } from '../../../shared/common.service';
import { HostListener } from '@angular/core';

@Component({
  selector: 'app-prior-medication-log',
  templateUrl: './prior-medication-log.component.html',
  styleUrl: './prior-medication-log.component.scss' })
export class PriorMedicationLogComponent implements OnInit {
  formName: string = 'prior-medication-log'; // Form name
  queryParams: any = {}; // To store query parameters
  formData: any = {
    priorMedicationLogs: []
  };

  studyId: string | null = null; // Study ID
  subjectId: string | null = null; // Subject ID
  studyCode: any; // Study Code
  studyName: any; // Study Name
  siteLocation: any; // Site Location
  todayDate: string;
  informedConsentDate: string;
  screeningMinDate: string;
  gender: any;
  folderName: any;
  subjectName: string | null;

  //query code
   tabs = [
  { title: 'Query', type: 'query' },
  { title: 'Field History', type: 'fieldHistory' }
];

  fieldHistoryData: any[] = [];
  selectedTab = 0;
  isOptionsModalOpen = false;
  isModalOpen = false;
  queryText = '';
  // closeQuery = false;
  auditTrail: { user: string; role: string; timestamp: string; message: string }[] = [];
  queries: {
    selectedField: any; threadId: string; text: string; isClosed:boolean; auditTrail: { user: string; role: string; timestamp: string; message: string }[] 
}[] = [
  { selectedField: null, threadId: this.generateThreadId(), text: '', isClosed: false , auditTrail: [] }
];
  selectedOption = 'query'; // Default to Query section
 showReviewModal = false;
  query: { auditTrail: any; };
  fieldLabel: string | null = null; // Add this at the top
  // query code end

isPriorLogDisabled: boolean = false;
isReasonModalOpen: boolean = false;
editReason: string = '';

 //review code
isReviewCheckboxDisabled: boolean = true;
userDesignation: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
     const userData = this.commonService.getUserData();
  console.log('User Data from Cookie:', userData);
     this.userDesignation = userData.designation?.toLowerCase(); // Save and normalize

    const isLoggedIn = this.commonService.isLoggedIn();
  console.log('Is Logged In:', isLoggedIn);

    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    this.todayDate = `${year}-${month}-${day}`;

    this.informedConsentDate = '';
    this.screeningMinDate = '';

    this.route.params.subscribe(params => {
      this.folderName = params['folderName'] ?? 'prior-medication';
      this.formName = params['formName'];
      console.log("Form Name:", this.formName);
    });

    this.route.queryParams.subscribe(queryParams => {
      this.studyId = queryParams['studyId'];
      this.subjectId = queryParams['subjectId'];
    });
    console.log("Extracted Params:", {
      studyId: this.studyId,
      subjectId: this.subjectId,
      folderName: this.folderName,
      formName: this.formName
    });

    if (this.studyId && this.subjectId && this.folderName && this.formName) {
      this.apiService.getFormData(this.studyId, this.subjectId, this.folderName, this.formName).subscribe({
        next: (response) => {
          console.log('Fetched Form Data:', response);
          if (response.success) {
            if (Array.isArray(response.data)) {
              this.mapFormData(response.data);
            } else {
              console.warn('Form data is not an array or is missing.');
            }
            this.mapStudyDetails(response.studyDetails);
            if (response.informedConsentDate !== undefined) {
              this.informedConsentDate = response.informedConsentDate;
              this.screeningMinDate = this.informedConsentDate;
              console.log("Informed Consent Date:", this.informedConsentDate);
            } else {
              console.warn('Informed consent date is missing in the response.');
            }
            this.gender = response.gender;
            console.log("gender:", this.gender);
          }
        },
        error: (error) => {
          console.error('Error fetching form data:', error);
        }
      });

      // const fieldName = '2. Date of Study Completion:';
      const fieldName = this.fieldLabel || 'Unknown Field';
  this.apiService.getInsertHistoryData(this.studyId, this.subjectId, this.folderName, this.formName, fieldName)
    .subscribe({
      next: (response) => {
        console.log('Fetched Field History for', fieldName, response);
        this.fieldHistoryData = response.data || [];
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });

    } else {
      console.error('Missing required parameters: studyId, subjectId, folderName, or formName.');
    }
  }



  addTab(label: string = 'Date of Study Completion') {
  const fieldName = label.trim(); // You can enhance this mapping if needed

  this.apiService.getInsertHistoryData(this.studyId, this.subjectId, this.folderName, this.formName, fieldName)
    .subscribe({
      next: (response) => {
        console.log('Fetched Field History for', fieldName, response);
        this.fieldHistoryData = response.data || [];
        
        // Add tab only after fetching data
        this.tabs.push({ title: 'Field History', type: 'fieldHistory' });
        this.selectedTab = this.tabs.length - 1;
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
}


generateThreadId(): string {
  return 'thread-' + Math.random().toString(36).substr(2, 9);
}







  selectTab(index: number) {
    this.selectedTab = index;
    const selected = this.tabs[index];
  if (selected.type === 'query') {
    // const fieldName = '2. Date of Study Completion:'; // Or dynamically set based on tab
    const fieldName = this.fieldLabel || 'Unknown Field';
    console.log('Fetching Query History for Field:', fieldName); // <-- Add this
    this.apiService.getQueryHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        console.log('Fetched Query History Data:', response);
        // You can decide how to display this – either integrate it into the auditTrail or a dedicated UI block
        // Example: populate audit trails per query
         if (response.data && Array.isArray(response.data)) {
          const auditTrail = response.data.map((item: any) => {
            const subData = item.sub_data ? JSON.parse(item.sub_data) : {};
            return {
              user: item.updated_by || 'Unknown',
              
              timestamp: subData.timestamp || item.updated_at,
              message: item.value || ''
            };
          });
       
        }
      },
      error: (error) => {
        console.error('Error fetching query history data:', error);
      }
    });
  }
   if (selected.type === 'fieldHistory') {
  if (this.formName === 'prior-medication-log') {
    // Loop over all logs and fetch history (like above)
    this.fieldHistoryData = [];

    this.formData.priorMedicationLogs.forEach((_, index) => {
      const fieldName = `prior medication log${index + 1}`;

      this.apiService.getInsertHistoryData(
        this.studyId,
        this.subjectId,
        this.folderName,
        this.formName,
        fieldName
      ).subscribe({
        next: (response) => {
          if (Array.isArray(response.data)) {
            this.fieldHistoryData.push(...response.data);
          }
        },
        error: (error) => {
          console.error('Error fetching field history for', fieldName, error);
        }
      });
    });
  } else {
    const fieldName = this.fieldLabel || 'Unknown Field';
    console.log('Fetching Field History for:', fieldName);
    this.apiService.getInsertHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        console.log('Fetched Field History Data:', response);
        this.fieldHistoryData = response.data || [];
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
  }
   }}
  
  closeTab(index: number, event: MouseEvent) {
    event.stopPropagation();
    this.tabs.splice(index, 1);
    if (this.selectedTab >= this.tabs.length) {
      this.selectedTab = this.tabs.length - 1;
    }
  }
openReviewModal() {
  this.showReviewModal = true;

  // Reset before fetching new data
  this.fieldHistoryData = [];

  if (
    this.formName === 'prior-medication-log' &&
    Array.isArray(this.formData.priorMedicationLogs)
  ) {
    const allReviewEntries: any[] = [];
    let completedRequests = 0;
    const totalRequests = this.formData.priorMedicationLogs.length;

    this.formData.priorMedicationLogs.forEach((_, idx) => {
      const fieldName = `prior medication log${idx + 1}`;
      console.log('Fetching Field History for:', fieldName);

      this.apiService.getInsertHistoryData(
        this.studyId,
        this.subjectId,
        this.folderName,
        this.formName,
        fieldName
      ).subscribe({
        next: (response) => {
          if (Array.isArray(response.data)) {
            this.fieldHistoryData.push(...response.data);
            allReviewEntries.push(...response.data);
          }
          completedRequests++;

          if (completedRequests === totalRequests) {
            this.calculateLatestReviewFlags(allReviewEntries);
          }
        },
        error: (err) => {
          console.error(`Error fetching field history for ${fieldName}:`, err);
          completedRequests++;
          if (completedRequests === totalRequests) {
            this.calculateLatestReviewFlags(allReviewEntries);
          }
        }
      });
    });

  } else {
    const fieldName = this.fieldLabel || 'Unknown Field';
    console.log('Opening Review Modal - Fetching Field History for:', fieldName);

    this.apiService.getInsertHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        this.fieldHistoryData = response.data || [];
        this.calculateLatestReviewFlags(this.fieldHistoryData);
      },
      error: (error) => {
        console.error('Error fetching field history data from review modal:', error);
      }
    });
  }
}

calculateLatestReviewFlags(historyData: any[]) {
  let latestReview = {
    dataMonitor: false,
    monitor: false,
    pi: false
  };

  const sortedData = [...historyData].sort(
    (a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
  );

  const flagsFound = {
    dataMonitor: false,
    monitor: false,
    pi: false
  };

  for (const entry of sortedData) {
    if (!entry.review_status) continue;

    try {
      const parsed = JSON.parse(entry.review_status);

      if (!flagsFound.dataMonitor && parsed.hasOwnProperty('dataMonitor')) {
        latestReview.dataMonitor = parsed.dataMonitor;
        flagsFound.dataMonitor = true;
      }

      if (!flagsFound.monitor && parsed.hasOwnProperty('monitor')) {
        latestReview.monitor = parsed.monitor;
        flagsFound.monitor = true;
      }

      if (!flagsFound.pi && parsed.hasOwnProperty('pi')) {
        latestReview.pi = parsed.pi;
        flagsFound.pi = true;
      }

      if (flagsFound.dataMonitor && flagsFound.monitor && flagsFound.pi) {
        break;
      }

    } catch (err) {
      console.error("Error parsing review_status JSON:", err);
    }
  }

  this.reviewOptions = latestReview;
  console.log("✅ Final reviewOptions applied:", this.reviewOptions);
}

closeReviewModal() {
  this.showReviewModal = false;
}
openOptionsModal(event: MouseEvent, target: EventTarget | null) {
  event.stopPropagation();
  this.isOptionsModalOpen = true;

  // Traverse to the closest parent with `data-label`
  const icon = target as HTMLElement;
  const fieldGroup = icon.closest('.form-group');

  if (fieldGroup) {
    this.fieldLabel = fieldGroup.getAttribute('data-label');
    console.log('Dynamically captured label:', this.fieldLabel);
  }
}



openModal() {
  this.isModalOpen = true;
  this.selectedTab = 0; // Default to 'Query'

  // const fieldName = '2. Date of Study Completion:'; // Or dynamically get it
  const fieldName = this.fieldLabel || 'Unknown Field';
 console.log("Opening modal - Fetching field name:", fieldName); // <-- Add this

  this.apiService.getQueryHistoryData(
    this.studyId,
    this.subjectId,
    this.folderName,
    this.formName,
    fieldName
  ).subscribe({
    next: (response) => {
      console.log('Fetched Query History Data:', response);

      if (response.success && Array.isArray(response.data)) {
        this.queries = response.data.map((entry: any) => {
          const auditTrail = entry.auditTrail?.map((a: any) => ({
            user: a.user,
            timestamp: a.timestamp,
            message: typeof a.message === 'string' ? a.message : String(a.message)
          })) || [];

          const isClosed = auditTrail.some(item => 
  typeof item.message === 'string' && item.message.toLowerCase().includes('query closed')
);

const query = {
  selectedField: entry.auditTrail?.[0]?.selectedField || '',
  threadId: entry.threadId || 'no-thread',
  text: this.getInitialQueryText(auditTrail) || '',
  isClosed: isClosed,
  auditTrail: auditTrail
};

         

          return query;
        });
      } else {
        // Fallback for empty or invalid data
        this.queries = Array(3).fill(null).map(() => ({
           selectedField: null,
          threadId: this.generateThreadId(),
          text: '',
          isClosed: false,
          auditTrail: []
        }));
      }
    },
    error: (error) => {
      console.error('Error fetching query history:', error);
      this.queries = [{
         selectedField: null,
        threadId: this.generateThreadId(),
        text: '',
        isClosed: false,
        auditTrail: []
      }];
    }
  });

  // Fetch Field History for Prior Medication Log
  if (this.formName === 'prior-medication-log' && Array.isArray(this.formData.priorMedicationLogs)) {
    this.fieldHistoryData = [];

    this.formData.priorMedicationLogs.forEach((_, index) => {
      const historyFieldName = `prior medication log${index + 1}`;

      this.apiService.getInsertHistoryData(
        this.studyId,
        this.subjectId,
        this.folderName,
        this.formName,
        historyFieldName
      ).subscribe({
        next: (response) => {
          console.log(`History for ${historyFieldName}:`, response);
          if (Array.isArray(response.data)) {
            this.fieldHistoryData.push(...response.data);
          }
        },
        error: (error) => {
          console.error(`Error fetching history for ${historyFieldName}:`, error);
        }
      });
    });
  }
}

getInitialQueryText(auditTrail: any[]): string {
  if (!Array.isArray(auditTrail)) return '';

  // Look for latest message or first valid message in each query's auditTrail
  const validEntry = auditTrail
    .filter(a => typeof a.message === 'string' && a.message.trim() && a.message.toLowerCase() !== 'query closed')
    .pop(); // or use [0] for first message

  return validEntry ? validEntry.message : '';
}

closeModal() {
  this.isModalOpen = false;
  document.body.classList.remove('modal-open');
}


addQuery(index: number) {
  this.queries.splice(index + 1, 0, {
     selectedField: null,
    threadId: this.generateThreadId(),
    text: '',
    isClosed: false,
    auditTrail: []
  });
}
submitQuery(index: number) {
  const userData = this.commonService.getUserData(); // Extract from cookies
  console.log('userData:', userData); // Check the structure
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A'; // Fallback if not available

  const timestamp = new Date().toISOString(); // ISO format for backend

  const query = this.queries[index];

  if (!query.text || !query.text.trim()) {
    console.warn('No text entered for this query. Ignoring submit.');
    return;
  }

  // Ensure threadId
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }
  
  if (!query.selectedField) {
  console.warn('No field selected for the query.');
  alert('Please select a field from the dropdown before submitting.');
  return;
}

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName :this.fieldLabel || 'Unknown Field',
    threadId: query.threadId,
    queryText: query.text.trim(),
    user: fullName,
    designation: designation,
    timestamp: timestamp,
    selectedField: query.selectedField || '' // <-- ADD THIS LINE
  };
   console.log('Submitting Query Payload:', payloadItem); // <-- Important log

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query submitted:', response);

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: new Date().toLocaleString(),
        message: payloadItem.queryText
      });
 query.text = ''; // Clear only this one
    },
    error: (error) => {
      console.error('Error submitting query:', error);
    }

     
    });
  }

reviewOptions = {
  dataMonitor: false,
  monitor: false,
  pi: false
};
 
confirmCloseQuery(index: number): void {
  const confirmed = window.confirm('Are you sure you want to close this query?');
  if (confirmed) {
    this.closeQuery(index);
  }
}
closeQuery(index: number): void {
  const userData = this.commonService.getUserData();
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A';
  const timestamp = new Date().toISOString(); // For backend
  const localTime = new Date().toLocaleString(); // For UI

  const query = this.queries[index];
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }

  const closeMessage = 'Query closed';

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName : this.fieldLabel || 'Unknown Field',
    threadId: query.threadId,
    queryText: closeMessage,
    user: fullName,
    designation: designation,
    timestamp: timestamp,
    isClosed: true  // Optional, in case your backend expects a flag
  };

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query closed:', response);
      

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: localTime,
        message: closeMessage
      });
      query.isClosed = true;
      alert('Query closed successfully');
    },
    error: (error) => {
      console.error('Error closing query:', error);
    }
  });
}
confirmSubmitQuery(index: number): void {
  const confirmSubmit = confirm('Are you sure you want to submit the data?');
  if (confirmSubmit) {
    this.submitQuery(index);
    alert('Data submitted successfully');
  }
}




  mapStudyDetails(studyDetails: any): void {
    if (studyDetails) {
      this.studyCode = studyDetails.study_code ?? 'N/A';
      this.studyName = studyDetails.study_name ?? 'Unknown Study';
      this.siteLocation = studyDetails.site_location ?? 'Unknown Location';
      this.subjectName = this.subjectId;
    } else {
      console.warn('Study details are missing or undefined.');
    }
  }
  updateEndDateRange(log: any) {
    if (log.startDate) {
      log.endDate = ''; // Clear previously selected end date if any
    }
  }
  hasMedicationData = false;

mapFormData(data: any[]): void {
  this.formData.priorMedicationLogs = [];
  this.hasMedicationData = false;

  this.reviewOptions = {
    dataMonitor: false,
    monitor: false,
    pi: false
  };

  data.forEach(item => {
    const fieldName = item.field_name?.trim().toLowerCase();
    const fieldValue = item.value;

    // Handle review checkboxes
    if (fieldName === 'reviewedbydatamonitor') {
      this.reviewOptions.dataMonitor = fieldValue === 'true';
    }
    if (fieldName === 'reviewedbymonitor') {
      this.reviewOptions.monitor = fieldValue === 'true';
    }
    if (fieldName === 'reviewedbypi') {
      this.reviewOptions.pi = fieldValue === 'true';
    }

    // Handle prior medication logs
    if ((fieldName?.includes('prior-medication-log') || fieldName?.includes('prior medication log')) && item.sub_data) {
      let subData: any = {};
      try {
        subData =
          typeof item.sub_data === 'string' && item.sub_data.trim()
            ? JSON.parse(item.sub_data)
            : {};
      } catch (e) {
        console.warn('Invalid JSON in sub_data:', item.sub_data);
        return;
      }

      this.formData.priorMedicationLogs.push({
        logLine:    subData.logLine    || '',
        drugName:   subData.drugName   || '',
        indication: subData.indication || '',
        startDate:  subData.startDate  || '',
        endDate:    subData.endDate    || '',
        route:      subData.route      || '',
        dosage:     subData.dosage     || '',
        frequency:  subData.frequency  || '',
        ongoing:    subData.ongoing    || ''
      });

      this.hasMedicationData = true;
    }
  });

  // Determine if any logs have values — to disable/enable editing
  this.isPriorLogDisabled = this.formData.priorMedicationLogs.some(log =>
    Object.values(log).some(v => v !== '' && v !== null)
  );

  // Ensure at least one log line exists
  if (this.formData.priorMedicationLogs.length === 0) {
    this.addLogLine();
  }

  console.log('Mapped Form Data:', this.formData);
}

  addLogLine(): void {
    this.formData.priorMedicationLogs.push({
      logLine: '',
      drugName: '',
      indication: '',
      startDate: '',
      endDate: '',
      route: '',
      dosage: '',
      frequency: '',
      ongoing: ''
    });
  }
editStudy() {
  this.isReasonModalOpen = true;
}

confirmEditReason() {
  if (!this.editReason.trim()) {
    alert('Please enter a reason before proceeding.');
    return;
  }
  this.isPriorLogDisabled = false;
  this.isReasonModalOpen = false;
}

cancelEditReason() {
  this.isReasonModalOpen = false;
  this.editReason = '';
}

  submitForm() {
     const userData = this.commonService.getUserData();
  const fullName = `${userData.first_name} ${userData.last_name}`;

    let questionAnswers: { [key: string]: any } = {};
    if (this.formName === 'prior-medication-log' && Array.isArray(this.formData.priorMedicationLogs)) {
      this.formData.priorMedicationLogs.forEach((log, index) => {
        let fieldKey = `prior medication log${index + 1}`;
        questionAnswers[fieldKey] = {
          answer: 'Yes',
          value: { ...log },
          editReason: this.editReason || '',
          reviewStatus: { ...this.reviewOptions }
        };
      });
    }
    const submittedData = {
      folderName: this.folderName,
      formName: this.formName,
      studyId: this.studyId,
      subjectId: this.subjectId,
       user: fullName,
      ...questionAnswers
    };
    this.apiService.insertFormData(submittedData).subscribe({
      next: (response) => {
        console.log("Response from API:", response);
        alert("Form Submitted Successfully!");
         this.editReason = '';
      this.isPriorLogDisabled = true;
      },
      error: (error) => {
        console.error("Error submitting form:", error);
        alert("Error submitting form. Please try again.");
      }
    });
  }

  goBack() {
    this.router.navigate(['/study-details', this.studyId]);
  }

    //new + import line to allow. closing of panel
@HostListener('document:click', ['$event'])
onClickOutside(event: MouseEvent) {
  const clickedInside = (event.target as HTMLElement)?.closest('.options-modal');
  if (!clickedInside) {
    this.isOptionsModalOpen = false;
  }
}
}
